export default defineNuxtPlugin(() => {
  const user = useSupabaseUser()
  const { clear } = usePrivateClientState()
  const signingOut = useState('auth-signing-out', () => false)
  let activeUserId = user.value?.id ?? null

  watch(
    () => user.value?.id ?? null,
    (userId) => {
      if (userId === activeUserId) return
      activeUserId = userId
      // Explicit logout owns cleanup after private views have unmounted.
      if (!signingOut.value) void clear()
    },
  )
})
